import React from 'react';

const HtmlText = ({text}: { text: string }) => {
  return (
    <div className={"html-container"} dangerouslySetInnerHTML={{__html: text}}></div>
  );
};

export default HtmlText;
